import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { APICONSTANTS } from './../constants/api-constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericCrudService } from './basic/generic.crud.service';
import { ToastrService } from 'ngx-toastr';
import { HostnameService } from './basic/hostname.service';
import { BcModel } from '../models/societe-linked/bc/bc.model';

@Injectable()
export class MailService extends GenericCrudService<BcModel> {
  protected header: HttpHeaders;

    constructor(http: HttpClient,
                protected toastrService: ToastrService,
                protected hostnameService: HostnameService) {
        super(http, toastrService, APICONSTANTS.ROUTEMAILS, hostnameService);
  }

  sendValidateurs(bc: BcModel): Observable<BcModel> {
    return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'SendValidateurs/', bc, {headers: this.header})
    .pipe(catchError(err => this.requestCatchError(err, 'L’envoie aux validateurs')));
  }
  sendDelegs(bc: BcModel): Observable<BcModel> {
    return this.http.post<BcModel>(APICONSTANTS.URLAPI.value + this.route + 'SendDeleg/', bc, {headers: this.header})
    .pipe(catchError(err => this.requestCatchError(err, 'L’envoie aux délégataires')));
  }
}